/**
 * PageShell — EINHEITLICHES Seitengerüst für ALLE Screens (DESIGN.md).
 *
 * Garantiert überall identisch:
 *   • Hintergrund bg-slate-50, volle Höhe
 *   • Sticky weiße Kopfleiste (full-bleed) mit zentriertem Inhalt
 *   • Gleiche Inhaltsbreite (max-w-7xl) und gleiche Seitenabstände
 *   • Mobiler Bottom-Nav-Freiraum (pb-24)
 *
 * Verwendung A (Standard):
 *   <PageShell icon={<X className="w-5 h-5" />} title="…" subtitle="…"
 *              actions={<Button/>} toolbar={<Filterzeile/>}> … </PageShell>
 * Verwendung B (bestehende Kopfzeile übernehmen):
 *   <PageShell head={<eigene Kopfzeile/>}> … </PageShell>
 */
import PageHeader from '@/components/ui/PageHeader';
import { cn } from '@/lib/utils';

const WRAP = 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8';

export default function PageShell({
  icon, title, subtitle, actions, toolbar, head, children, className, mainClassName,
}) {
  return (
    <div className={cn('min-h-screen bg-slate-50', className)}>
      <header className="sticky top-0 z-20 bg-white border-b border-slate-200">
        <div className={cn(WRAP, 'py-4')}>
          {head || (
            <PageHeader icon={icon} title={title} subtitle={subtitle} actions={actions} />
          )}
          {toolbar && <div className="mt-4">{toolbar}</div>}
        </div>
      </header>
      <main className={cn(WRAP, 'pt-6 pb-24 space-y-4', mainClassName)}>
        {children}
      </main>
    </div>
  );
}
